import { render, staticRenderFns } from "./ChecklistInspectionForm.vue?vue&type=template&id=424552b0&scoped=true"
import script from "./ChecklistInspectionForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ChecklistInspectionForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChecklistInspectionForm.vue?vue&type=style&index=0&id=424552b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424552b0",
  null
  
)

export default component.exports